const zh = {
    login:{ 
    	title:'我是标题',
    },

    tip: {
        payment_currency: '支付币种',
        payment_amount: '支付金额',
    }
}
export default zh;
